import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "admin-form panel-form" };
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = { class: "col-span-6 xl:col-span-4" };
const _hoisted_4 = {
    id: "slug",
    class: "appearance-none block w-full py-3 rounded-md placeholder-slate-400 text-sm mt-2"
};
const _hoisted_5 = ["href"];
const _hoisted_6 = {
    key: 1,
    class: "font-medium"
};
const _hoisted_7 = { class: "mt-2" };
const _hoisted_8 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_9 = { class: "mt-2" };
const _hoisted_10 = ["placeholder"];
const _hoisted_11 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_12 = { class: "flex items-center" };
const _hoisted_13 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_14 = { class: "flex items-center" };
const _hoisted_15 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_16 = { class: "admin-form panel-form" };
const _hoisted_17 = { class: "form-group" };
const _hoisted_18 = { class: "mt-2" };
const _hoisted_19 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_20 = { class: "admin-form panel-form" };
const _hoisted_21 = { class: "mt-6" };
const _hoisted_22 = { class: "text-red-500 p-1 bg-slate-100" };
const _hoisted_23 = { class: "form-group relative" };
const _hoisted_24 = { class: "flex pb-4 justify-end xl:pb-0 xl:absolute xl:top-0 xl:right-0" };
const _hoisted_25 = ["for"];
const _hoisted_26 = { class: "flex mt-2" };
const _hoisted_27 = ["name", "id", "onUpdate:modelValue"];
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["aria-labelledby"];
const _hoisted_30 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_31 = {
    key: 1,
    class: "col-span-6"
};
const _hoisted_32 = {
    key: 0,
    class: "admin-form panel-form"
};
const _hoisted_33 = { class: "form-group" };
const _hoisted_34 = { class: "mt-2" };
const _hoisted_35 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_36 = { class: "mt-2" };
const _hoisted_37 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_38 = { class: "mt-2" };
const _hoisted_39 = ["value"];
const _hoisted_40 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_41 = {
    key: 1,
    class: "admin-form panel-form"
};
const _hoisted_42 = { class: "form-group" };
const _hoisted_43 = { class: "mt-2" };
const _hoisted_44 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_45 = { class: "mt-2" };
const _hoisted_46 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_47 = { for: "processor_secret" };
const _hoisted_48 = {
    key: 0,
    class: "req-asterisk"
};
const _hoisted_49 = { class: "mt-2" };
const _hoisted_50 = ["placeholder"];
const _hoisted_51 = { key: 2 };
const _hoisted_52 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_53 = { class: "mt-2" };
const _hoisted_54 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_55 = { for: "processor_password" };
const _hoisted_56 = {
    key: 0,
    class: "req-asterisk"
};
const _hoisted_57 = { class: "mt-2" };
const _hoisted_58 = { key: 2 };
const _hoisted_59 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_60 = {
    key: 2,
    class: "admin-form panel-form"
};
const _hoisted_61 = { class: "form-group" };
const _hoisted_62 = { class: "mt-2" };
const _hoisted_63 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_64 = { for: "simfoni_retail_token" };
const _hoisted_65 = {
    key: 0,
    class: "req-asterisk"
};
const _hoisted_66 = { class: "mt-2" };
const _hoisted_67 = ["placeholder"];
const _hoisted_68 = { key: 2 };
const _hoisted_69 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_70 = { class: "admin-form panel-form" };
const _hoisted_71 = { class: "form-group" };
const _hoisted_72 = { class: "mt-2" };
const _hoisted_73 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_74 = { class: "mt-2" };
const _hoisted_75 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_76 = { class: "mt-2" };
const _hoisted_77 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_78 = { class: "mt-2" };
const _hoisted_79 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_80 = { class: "mt-2" };
const _hoisted_81 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_82 = { class: "mt-2" };
const _hoisted_83 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_84 = { class: "mt-2" };
const _hoisted_85 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_86 = { class: "mt-2" };
const _hoisted_87 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_88 = { class: "mt-2" };
const _hoisted_89 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_90 = { class: "mt-2" };
const _hoisted_91 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_92 = { class: "admin-form panel-form" };
const _hoisted_93 = { class: "form-group" };
const _hoisted_94 = { class: "mt-2" };
const _hoisted_95 = {
    key: 0,
    class: "p-2 border border-dotted border-slate-400 mb-6"
};
const _hoisted_96 = ["src"];
const _hoisted_97 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_98 = { class: "mt-2" };
const _hoisted_99 = {
    key: 0,
    class: "p-2 border border-dotted border-slate-400 mb-6"
};
const _hoisted_100 = ["src"];
const _hoisted_101 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_102 = { class: "mt-2" };
const _hoisted_103 = {
    key: 0,
    class: "p-2 border border-dotted border-slate-400 mb-6"
};
const _hoisted_104 = ["src"];
const _hoisted_105 = {
    key: 0,
    class: "input-error-message text-sm"
};
const _hoisted_106 = { class: "mt-2" };
const _hoisted_107 = {
    key: 0,
    class: "p-2 border border-dotted border-slate-400 mb-6"
};
const _hoisted_108 = ["src"];
const _hoisted_109 = {
    key: 0,
    class: "input-error-message text-sm"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_editor = _resolveComponent("editor");
    const _component_FileUpload = _resolveComponent("FileUpload");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("section", _hoisted_1, [
            _cache[37] || (_cache[37] = _createElementVNode("aside", null, [
                _createElementVNode("h2", { class: "font-medium text-lg" }, "Account Information"),
                _createElementVNode("p", null, [
                    _createTextVNode(" Accounts will be accessed using the the name provided e.g. "),
                    _createElementVNode("dfn", { class: "font-medium not-italic" }, "acme-inc"),
                    _createTextVNode(" would be available at "),
                    _createElementVNode("cite", { class: "font-medium not-italic" }, "https://acme-inc.chooza.gift"),
                    _createTextVNode(". ")
                ])
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _cache[29] || (_cache[29] = _createElementVNode("label", { for: "slug" }, [
                        _createTextVNode("Portal"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("p", _hoisted_4, [
                        (_ctx.value.getPortalEndpoint())
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: _ctx.value.getPortalEndpoint(),
                                target: "_blank"
                            }, _toDisplayString(_ctx.value.getPortalEndpoint()), 9, _hoisted_5))
                            : (_openBlock(), _createElementBlock("span", _hoisted_6, " Select an Account Name "))
                    ])
                ]),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('name') }])
                }, [
                    _cache[30] || (_cache[30] = _createElementVNode("label", { for: "name" }, [
                        _createTextVNode("Name"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "name",
                            id: "name",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value.data.name) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.name]
                        ])
                    ]),
                    (_ctx.value.fieldHasErrors('name'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.value.getFieldError('name')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('mail_from') }])
                }, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", { for: "mail_from" }, "Mail From", -1)),
                    _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "mail_from",
                            id: "mail_from",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.value.data.mail_from) = $event)),
                            placeholder: _ctx.app.mail.address
                        }, null, 8, _hoisted_10), [
                            [_vModelText, _ctx.value.data.mail_from]
                        ])
                    ]),
                    _createElementVNode("p", null, [
                        _createElementVNode("small", null, [
                            _createTextVNode(" The address that system emails come from (default " + _toDisplayString(_ctx.app.mail.address) + "), ", 1),
                            _cache[31] || (_cache[31] = _createElementVNode("span", { class: "font-medium underline" }, "do not", -1)),
                            _cache[32] || (_cache[32] = _createTextVNode(" alter this setting until the domain has been verified in AWS SES. Doing so may result in emails failing to send for this account. ", -1))
                        ])
                    ]),
                    (_ctx.value.fieldHasErrors('mail_from'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.value.getFieldError('mail_from')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('pin_verification') }])
                }, [
                    _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                            id: "pin_verification",
                            name: "pin_verification",
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.value.data.pin_verification) = $event))
                        }, null, 512), [
                            [_vModelCheckbox, _ctx.value.data.pin_verification]
                        ]),
                        _cache[34] || (_cache[34] = _createElementVNode("label", {
                            for: "pin_verification",
                            class: "ml-2 block text-sm text-slate-900"
                        }, "PIN Verification", -1))
                    ]),
                    _cache[35] || (_cache[35] = _createElementVNode("p", null, [
                        _createElementVNode("small", null, " Enabling PIN Verification means that users will be required to enter the codes PIN number (if applicable) when redeeming their prepaid codes. ")
                    ], -1)),
                    (_ctx.value.fieldHasErrors('pin_verification'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.value.getFieldError('pin_verification')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('active') }])
                }, [
                    _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                            id: "active",
                            name: "active",
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.value.data.active) = $event))
                        }, null, 512), [
                            [_vModelCheckbox, _ctx.value.data.active]
                        ]),
                        _cache[36] || (_cache[36] = _createElementVNode("label", {
                            for: "active",
                            class: "ml-2 block text-sm text-slate-900"
                        }, "Active", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('active'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.value.getFieldError('active')), 1))
                        : _createCommentVNode("", true)
                ], 2)
            ])
        ]),
        _createElementVNode("section", _hoisted_16, [
            _cache[39] || (_cache[39] = _createElementVNode("aside", null, [
                _createElementVNode("h2", { class: "font-medium text-lg" }, "Legal"),
                _createElementVNode("p", null, " The terms of service that are displayed on the account portal (these are not the same terms of service that Chooza Gift is using). ")
            ], -1)),
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6", { 'form-control-error': _ctx.value.fieldHasErrors('terms') }])
                }, [
                    _cache[38] || (_cache[38] = _createElementVNode("label", { for: "terms" }, [
                        _createTextVNode("Terms of Service"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_editor, {
                            id: "terms",
                            "api-key": _ctx.app.tinymce_key,
                            modelValue: _ctx.value.data.terms,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.value.data.terms) = $event)),
                            init: { height: 500 }
                        }, null, 8, ["api-key", "modelValue"])
                    ]),
                    (_ctx.value.fieldHasErrors('terms'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.value.getFieldError('terms')), 1))
                        : _createCommentVNode("", true)
                ], 2)
            ])
        ]),
        _createElementVNode("section", _hoisted_20, [
            _createElementVNode("aside", null, [
                _cache[43] || (_cache[43] = _createElementVNode("h2", { class: "font-medium text-lg" }, "Custom Domains", -1)),
                _cache[44] || (_cache[44] = _createElementVNode("p", null, " You can set up custom account domains for your account/campaigns by adding the domain here. ", -1)),
                _createElementVNode("p", _hoisted_21, [
                    _cache[40] || (_cache[40] = _createTextVNode(" Make sure you ", -1)),
                    _cache[41] || (_cache[41] = _createElementVNode("span", { class: "font-medium" }, "create a CNAME DNS record", -1)),
                    _cache[42] || (_cache[42] = _createTextVNode(" for your domain that points to ", -1)),
                    _createElementVNode("code", _hoisted_22, _toDisplayString(_ctx.app.domain), 1)
                ])
            ]),
            _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("button", {
                        type: "button",
                        class: "dark w-36",
                        onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.value.addDomain()), ["prevent"]))
                    }, "Add Domain")
                ]),
                (_ctx.value.data.domains && _ctx.value.data.domains.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.value.data.domains, (domain, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('domains.' + index + '.domain') }])
                        }, [
                            _createElementVNode("label", {
                                for: `domain[${index}]`
                            }, "Custom Domain # " + _toDisplayString((index + 1)), 9, _hoisted_25),
                            _createElementVNode("div", _hoisted_26, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    name: `domain[${index}]`,
                                    id: `domain[${index}]`,
                                    autocomplete: "off",
                                    "onUpdate:modelValue": ($event) => ((domain.domain) = $event),
                                    required: ""
                                }, null, 8, _hoisted_27), [
                                    [_vModelText, domain.domain]
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "error ml-4",
                                    "aria-label": "Delete Domain",
                                    onClick: ($event) => (_ctx.value.removeDomain(index))
                                }, [
                                    (_openBlock(), _createElementBlock("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        class: "h-5 w-5 font-medium",
                                        fill: "none",
                                        viewBox: "0 0 24 24",
                                        stroke: "currentColor",
                                        "stroke-width": "2",
                                        focusable: "false",
                                        "aria-labelledby": `domain[${index}]`
                                    }, [...(_cache[45] || (_cache[45] = [
                                            _createElementVNode("title", null, "Delete", -1),
                                            _createElementVNode("path", {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                            }, null, -1)
                                        ]))], 8, _hoisted_29))
                                ], 8, _hoisted_28)
                            ]),
                            (_ctx.value.fieldHasErrors('domains.' + index + '.domain'))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.value.getFieldError('domains.' + index + '.domain')), 1))
                                : _createCommentVNode("", true)
                        ], 2));
                    }), 256))
                    : (_openBlock(), _createElementBlock("div", _hoisted_31, [...(_cache[46] || (_cache[46] = [
                            _createStaticVNode("<div class=\"no-results panel py-6 px-10 mt-4\"><div class=\"text-slate-200 my-6\"><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-16 w-16 mx-auto\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\" stroke-width=\"2\"><title>No Domains</title><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9\"></path></svg></div><h2 id=\"no-domains\" class=\"text-slate-600 font-medium text-2xl text-center\">No Domains</h2><p class=\"text-center mt-4 text-sm text-slate-700\"> There are no custom domains attached to this account. </p></div>", 1)
                        ]))]))
            ])
        ]),
        (_ctx.isNotEditing && _ctx.permissions.isAdmin())
            ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                _cache[51] || (_cache[51] = _createElementVNode("aside", null, [
                    _createElementVNode("h2", { class: "font-medium text-lg" }, "User Information"),
                    _createElementVNode("p", null, " If presented, a user will be created and invited to this account. ")
                ], -1)),
                _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('user_name') }])
                    }, [
                        _cache[47] || (_cache[47] = _createElementVNode("label", { for: "user_name" }, "User Name", -1)),
                        _createElementVNode("div", _hoisted_34, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "user_name",
                                id: "user_name",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.value.data.user_name) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.value.data.user_name]
                            ])
                        ]),
                        (_ctx.value.fieldHasErrors('user_name'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(_ctx.value.getFieldError('user_name')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('user_email') }])
                    }, [
                        _cache[48] || (_cache[48] = _createElementVNode("label", { for: "user_email" }, "Email", -1)),
                        _createElementVNode("div", _hoisted_36, [
                            _withDirectives(_createElementVNode("input", {
                                type: "email",
                                name: "user_email",
                                id: "user_email",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.value.data.user_email) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.value.data.user_email]
                            ])
                        ]),
                        (_ctx.value.fieldHasErrors('user_email'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.value.getFieldError('user_email')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('user_role') }])
                    }, [
                        _cache[50] || (_cache[50] = _createElementVNode("label", { for: "user_role" }, "Role", -1)),
                        _createElementVNode("div", _hoisted_38, [
                            _withDirectives(_createElementVNode("select", {
                                name: "user_role",
                                id: "user_role",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.value.data.user_role) = $event))
                            }, [
                                _cache[49] || (_cache[49] = _createElementVNode("option", { value: null }, "No Role", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                                    return (_openBlock(), _createElementBlock("option", { value: role }, _toDisplayString(_ctx.f.capitalize(role.replace('_', ' '))), 9, _hoisted_39));
                                }), 256))
                            ], 512), [
                                [_vModelSelect, _ctx.value.data.user_role]
                            ])
                        ]),
                        (_ctx.value.fieldHasErrors('user_role'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_ctx.value.getFieldError('user_role')), 1))
                            : _createCommentVNode("", true)
                    ], 2)
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.permissions.isAdmin())
            ? (_openBlock(), _createElementBlock("section", _hoisted_41, [
                _cache[59] || (_cache[59] = _createElementVNode("aside", null, [
                    _createElementVNode("h2", { class: "font-medium text-lg" }, "Inspired Deck"),
                    _createElementVNode("p", null, [
                        _createElementVNode("a", {
                            href: "https://inspireddeck.co.uk",
                            target: "_blank"
                        }, "Inspired Deck"),
                        _createTextVNode(" API credentials, used for balance checks and redemptions of codes. ")
                    ])
                ], -1)),
                _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('processor_endpoint') }])
                    }, [
                        _cache[52] || (_cache[52] = _createElementVNode("label", { for: "processor_endpoint" }, [
                            _createTextVNode("Endpoint"),
                            _createElementVNode("span", { class: "req-asterisk" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_43, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "processor_endpoint",
                                id: "processor_endpoint",
                                required: "",
                                "aria-required": "true",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.value.data.processor_endpoint) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.value.data.processor_endpoint]
                            ])
                        ]),
                        (_ctx.value.fieldHasErrors('processor_endpoint'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_ctx.value.getFieldError('processor_endpoint')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('processor_client_id') }])
                    }, [
                        _cache[53] || (_cache[53] = _createElementVNode("label", { for: "processor_client_id" }, [
                            _createTextVNode("Client ID"),
                            _createElementVNode("span", { class: "req-asterisk" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_45, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "processor_client_id",
                                id: "processor_client_id",
                                required: "",
                                "aria-required": "true",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.value.data.processor_client_id) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.value.data.processor_client_id]
                            ])
                        ]),
                        (_ctx.value.fieldHasErrors('processor_client_id'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_ctx.value.getFieldError('processor_client_id')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('processor_secret') }])
                    }, [
                        _createElementVNode("label", _hoisted_47, [
                            _cache[54] || (_cache[54] = _createTextVNode("Secret", -1)),
                            (_ctx.isNotEditing)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_48, "*"))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_49, [
                            (_ctx.isEditing)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "text",
                                    name: "processor_secret",
                                    id: "processor_secret",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.value.data.processor_secret) = $event)),
                                    placeholder: _ctx.value.data.processor_secret_masked
                                }, null, 8, _hoisted_50)), [
                                    [_vModelText, _ctx.value.data.processor_secret]
                                ])
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "text",
                                    name: "processor_secret",
                                    id: "processor_secret",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.value.data.processor_secret) = $event))
                                }, null, 512)), [
                                    [_vModelText, _ctx.value.data.processor_secret]
                                ]),
                            (_ctx.isEditing)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_51, [...(_cache[55] || (_cache[55] = [
                                        _createTextVNode(" For security reasons the ", -1),
                                        _createElementVNode("span", { class: "font-medium" }, "processor secret", -1),
                                        _createTextVNode(" has been masked, leaving this empty will not update the saved credentials. ", -1)
                                    ]))]))
                                : _createCommentVNode("", true)
                        ]),
                        (_ctx.value.fieldHasErrors('processor_secret'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_52, _toDisplayString(_ctx.value.getFieldError('processor_secret')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('processor_username') }])
                    }, [
                        _cache[56] || (_cache[56] = _createElementVNode("label", { for: "processor_username" }, [
                            _createTextVNode("Username"),
                            _createElementVNode("span", { class: "req-asterisk" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_53, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "processor_username",
                                id: "processor_username",
                                required: "",
                                "aria-required": "true",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.value.data.processor_username) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.value.data.processor_username]
                            ])
                        ]),
                        (_ctx.value.fieldHasErrors('processor_username'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_54, _toDisplayString(_ctx.value.getFieldError('processor_username')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('processor_password') }])
                    }, [
                        _createElementVNode("label", _hoisted_55, [
                            _cache[57] || (_cache[57] = _createTextVNode("Password", -1)),
                            (_ctx.isNotEditing)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_56, "*"))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                            (_ctx.isEditing)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "password",
                                    name: "processor_password",
                                    id: "processor_password",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.value.data.processor_password) = $event))
                                }, null, 512)), [
                                    [_vModelText, _ctx.value.data.processor_password]
                                ])
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "password",
                                    name: "processor_password",
                                    id: "processor_password",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((_ctx.value.data.processor_password) = $event))
                                }, null, 512)), [
                                    [_vModelText, _ctx.value.data.processor_password]
                                ]),
                            (_ctx.isEditing)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_58, [...(_cache[58] || (_cache[58] = [
                                        _createTextVNode(" For security reasons the ", -1),
                                        _createElementVNode("span", { class: "font-medium" }, "processor password", -1),
                                        _createTextVNode(" has not been returned, leaving this empty will not update the saved credentials. ", -1)
                                    ]))]))
                                : _createCommentVNode("", true)
                        ]),
                        (_ctx.value.fieldHasErrors('processor_password'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_59, _toDisplayString(_ctx.value.getFieldError('processor_password')), 1))
                            : _createCommentVNode("", true)
                    ], 2)
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.permissions.isAdmin())
            ? (_openBlock(), _createElementBlock("section", _hoisted_60, [
                _cache[63] || (_cache[63] = _createElementVNode("aside", null, [
                    _createElementVNode("h2", { class: "font-medium text-lg" }, "Simfoni Retail"),
                    _createElementVNode("p", null, [
                        _createElementVNode("a", { href: "https://simfoni.io" }, "Simfoni Retail"),
                        _createTextVNode(" API credentials, used for order Chooza codes and placing Gift Card orders through the redemption portal. The supplied credentials should be linked to the relevant account as the financial management will be controlled from Simfoni Retail. ")
                    ])
                ], -1)),
                _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('simfoni_retail_endpoint') }])
                    }, [
                        _cache[60] || (_cache[60] = _createElementVNode("label", { for: "simfoni_retail_endpoint" }, [
                            _createTextVNode("Simfoni Retail Endpoint"),
                            _createElementVNode("span", { class: "req-asterisk" }, "*")
                        ], -1)),
                        _createElementVNode("div", _hoisted_62, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                name: "simfoni_retail_endpoint",
                                id: "simfoni_retail_endpoint",
                                required: "",
                                "aria-required": "true",
                                autocomplete: "off",
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.value.data.simfoni_retail_endpoint) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.value.data.simfoni_retail_endpoint]
                            ])
                        ]),
                        (_ctx.value.fieldHasErrors('simfoni_retail_endpoint'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(_ctx.value.getFieldError('simfoni_retail_endpoint')), 1))
                            : _createCommentVNode("", true)
                    ], 2),
                    _createElementVNode("div", {
                        class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('simfoni_retail_token') }])
                    }, [
                        _createElementVNode("label", _hoisted_64, [
                            _cache[61] || (_cache[61] = _createTextVNode("API Token", -1)),
                            (_ctx.isNotEditing)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_65, "*"))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                            (_ctx.isEditing)
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "text",
                                    name: "simfoni_retail_token",
                                    id: "simfoni_retail_token",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((_ctx.value.data.simfoni_retail_token) = $event)),
                                    placeholder: _ctx.value.data.simfoni_retail_token_masked
                                }, null, 8, _hoisted_67)), [
                                    [_vModelText, _ctx.value.data.simfoni_retail_token]
                                ])
                                : _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    type: "text",
                                    name: "simfoni_retail_token",
                                    id: "simfoni_retail_token",
                                    required: "",
                                    "aria-required": "true",
                                    autocomplete: "off",
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.value.data.simfoni_retail_token) = $event))
                                }, null, 512)), [
                                    [_vModelText, _ctx.value.data.simfoni_retail_token]
                                ]),
                            (_ctx.isEditing)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_68, [...(_cache[62] || (_cache[62] = [
                                        _createTextVNode(" For security reasons the ", -1),
                                        _createElementVNode("span", { class: "font-medium" }, "api token", -1),
                                        _createTextVNode(" has been masked, leaving this empty will not update the saved credentials. ", -1)
                                    ]))]))
                                : _createCommentVNode("", true)
                        ]),
                        (_ctx.value.fieldHasErrors('simfoni_retail_token'))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_69, _toDisplayString(_ctx.value.getFieldError('simfoni_retail_token')), 1))
                            : _createCommentVNode("", true)
                    ], 2)
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("section", _hoisted_70, [
            _cache[81] || (_cache[81] = _createElementVNode("aside", null, [
                _createElementVNode("h2", { class: "font-medium text-lg" }, "Portal Styling"),
                _createElementVNode("p", null, " Adjust the look and feel of the redemption portal. ")
            ], -1)),
            _createElementVNode("div", _hoisted_71, [
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4 xl:col-start-1", { 'form-control-error': _ctx.value.fieldHasErrors('primary_color') }])
                }, [
                    _cache[64] || (_cache[64] = _createElementVNode("label", { for: "primary_color" }, [
                        _createTextVNode("Primary Color"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_72, [
                        _withDirectives(_createElementVNode("input", {
                            type: "color",
                            name: "primary_color",
                            id: "primary_color",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((_ctx.value.data.primary_color) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.primary_color]
                        ])
                    ]),
                    (_ctx.value.fieldHasErrors('primary_color'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(_ctx.value.getFieldError('primary_color')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-2 xl:col-start-1", { 'form-control-error': _ctx.value.fieldHasErrors('primary_lighter_percentage') }])
                }, [
                    _cache[66] || (_cache[66] = _createElementVNode("label", { for: "primary_lighter_percentage" }, [
                        _createTextVNode("Primary Lighter Shade (%)"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_74, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "100",
                            step: "10",
                            name: "primary_lighter_percentage",
                            id: "primary_lighter_percentage",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.value.data.primary_lighter_percentage) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.primary_lighter_percentage]
                        ]),
                        _cache[65] || (_cache[65] = _createElementVNode("small", null, " The lighter shade (in percent) of the selected primary color, this color is primarily used for button and link hovers. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('primary_lighter_percentage'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_75, _toDisplayString(_ctx.value.getFieldError('primary_lighter_percentage')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-2 xl:col-start-3", { 'form-control-error': _ctx.value.fieldHasErrors('primary_darker_percentage') }])
                }, [
                    _cache[68] || (_cache[68] = _createElementVNode("label", { for: "primary_darker_percentage" }, [
                        _createTextVNode("Primary Darker Shade (%)"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_76, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "100",
                            step: "10",
                            name: "primary_darker_percentage",
                            id: "primary_darker_percentage",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((_ctx.value.data.primary_darker_percentage) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.primary_darker_percentage]
                        ]),
                        _cache[67] || (_cache[67] = _createElementVNode("small", null, " The darker shade (in percent) of the selected primary color, this color is primarily used for button and link hovers. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('primary_darker_percentage'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(_ctx.value.getFieldError('primary_darker_percentage')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('secondary_color') }])
                }, [
                    _cache[69] || (_cache[69] = _createElementVNode("label", { for: "secondary_color" }, [
                        _createTextVNode("Secondary Color"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_78, [
                        _withDirectives(_createElementVNode("input", {
                            type: "color",
                            name: "secondary_color",
                            id: "secondary_color",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.value.data.secondary_color) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.secondary_color]
                        ])
                    ]),
                    (_ctx.value.fieldHasErrors('secondary_color'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_79, _toDisplayString(_ctx.value.getFieldError('secondary_color')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-2 xl:col-start-1", { 'form-control-error': _ctx.value.fieldHasErrors('secondary_lighter_percentage') }])
                }, [
                    _cache[71] || (_cache[71] = _createElementVNode("label", { for: "secondary_lighter_percentage" }, [
                        _createTextVNode("Secondary Lighter Shade (%)"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_80, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "100",
                            step: "10",
                            name: "secondary_lighter_percentage",
                            id: "secondary_lighter_percentage",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((_ctx.value.data.secondary_lighter_percentage) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.secondary_lighter_percentage]
                        ]),
                        _cache[70] || (_cache[70] = _createElementVNode("small", null, " The lighter shade (in percent) of the selected secondary color, this color is primarily used for button and link hovers. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('secondary_lighter_percentage'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_81, _toDisplayString(_ctx.value.getFieldError('secondary_lighter_percentage')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-2 xl:col-start-3", { 'form-control-error': _ctx.value.fieldHasErrors('secondary_darker_percentage') }])
                }, [
                    _cache[73] || (_cache[73] = _createElementVNode("label", { for: "secondary_darker_percentage" }, [
                        _createTextVNode("Secondary Darker Shade (%)"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_82, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "100",
                            step: "10",
                            name: "secondary_darker_percentage",
                            id: "secondary_darker_percentage",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((_ctx.value.data.secondary_darker_percentage) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.secondary_darker_percentage]
                        ]),
                        _cache[72] || (_cache[72] = _createElementVNode("small", null, " The darker shade (in percent) of the selected secondary color, this color is primarily used for button and link hovers. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('secondary_darker_percentage'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString(_ctx.value.getFieldError('secondary_darker_percentage')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('tertiary_color') }])
                }, [
                    _cache[74] || (_cache[74] = _createElementVNode("label", { for: "tertiary_color" }, [
                        _createTextVNode("Tertiary Color"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_84, [
                        _withDirectives(_createElementVNode("input", {
                            type: "color",
                            name: "tertiary_color",
                            id: "tertiary_color",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((_ctx.value.data.tertiary_color) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.tertiary_color]
                        ])
                    ]),
                    (_ctx.value.fieldHasErrors('tertiary_color'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_85, _toDisplayString(_ctx.value.getFieldError('tertiary_color')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-2 xl:col-start-1", { 'form-control-error': _ctx.value.fieldHasErrors('tertiary_lighter_percentage') }])
                }, [
                    _cache[76] || (_cache[76] = _createElementVNode("label", { for: "tertiary_lighter_percentage" }, [
                        _createTextVNode("Tertiary Lighter Shade (%)"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_86, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "100",
                            step: "10",
                            name: "tertiary_lighter_percentage",
                            id: "tertiary_lighter_percentage",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.value.data.tertiary_lighter_percentage) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.tertiary_lighter_percentage]
                        ]),
                        _cache[75] || (_cache[75] = _createElementVNode("small", null, " The lighter shade (in percent) of the selected tertiary color, this color is primarily used for button and link hovers. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('tertiary_lighter_percentage'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_87, _toDisplayString(_ctx.value.getFieldError('tertiary_lighter_percentage')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-2 xl:col-start-3", { 'form-control-error': _ctx.value.fieldHasErrors('tertiary_darker_percentage') }])
                }, [
                    _cache[78] || (_cache[78] = _createElementVNode("label", { for: "tertiary_darker_percentage" }, [
                        _createTextVNode("Tertiary Darker Shade (%)"),
                        _createElementVNode("span", { class: "req-asterisk" }, "*")
                    ], -1)),
                    _createElementVNode("div", _hoisted_88, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            min: "0",
                            max: "100",
                            step: "10",
                            name: "tertiary_darker_percentage",
                            id: "tertiary_darker_percentage",
                            required: "",
                            "aria-required": "true",
                            autocomplete: "off",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((_ctx.value.data.tertiary_darker_percentage) = $event))
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.tertiary_darker_percentage]
                        ]),
                        _cache[77] || (_cache[77] = _createElementVNode("small", null, " The darker shade (in percent) of the selected tertiary color, this color is primarily used for button and link hovers. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('tertiary_darker_percentage'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_89, _toDisplayString(_ctx.value.getFieldError('tertiary_darker_percentage')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('custom_css') }])
                }, [
                    _cache[80] || (_cache[80] = _createElementVNode("label", { for: "custom_css" }, "Custom CSS", -1)),
                    _createElementVNode("div", _hoisted_90, [
                        _withDirectives(_createElementVNode("textarea", {
                            id: "custom_css",
                            name: "custom_css",
                            rows: "8",
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.value.data.custom_css) = $event)),
                            autocomplete: "off"
                        }, null, 512), [
                            [_vModelText, _ctx.value.data.custom_css]
                        ]),
                        _cache[79] || (_cache[79] = _createElementVNode("small", null, " Custom CSS styling for the portal redemption page. Changes here will override the default styling colours will be handled by the options above. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('custom_css'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_91, _toDisplayString(_ctx.value.getFieldError('custom_css')), 1))
                        : _createCommentVNode("", true)
                ], 2)
            ])
        ]),
        _createElementVNode("section", _hoisted_92, [
            _cache[94] || (_cache[94] = _createElementVNode("aside", null, [
                _createElementVNode("h2", { class: "font-medium text-lg" }, "Portal Images"),
                _createElementVNode("p", null, " Set the images that will appear on the redemption portal. ")
            ], -1)),
            _createElementVNode("div", _hoisted_93, [
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('upload_asset_logo') }])
                }, [
                    _cache[84] || (_cache[84] = _createElementVNode("label", { for: "upload_asset_logo" }, "Logo", -1)),
                    _createElementVNode("div", _hoisted_94, [
                        (_ctx.value.data.asset_logo_endpoint)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                _createElementVNode("img", {
                                    src: _ctx.value.data.asset_logo_endpoint,
                                    alt: "Logo",
                                    class: "object-contain h-20 mx-auto"
                                }, null, 8, _hoisted_96)
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(_component_FileUpload, {
                            label: "Logo",
                            name: "upload_asset_logo",
                            id: "upload_asset_logo",
                            value: _ctx.value
                        }, {
                            default: _withCtx(() => [...(_cache[82] || (_cache[82] = [
                                    _createTextVNode(" PNG, JPG or GIF ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["value"]),
                        _cache[83] || (_cache[83] = _createElementVNode("small", null, " The main logo that is displayed on the redemption portal and any order notifications. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('upload_asset_logo'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_97, _toDisplayString(_ctx.value.getFieldError('upload_asset_logo')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('upload_asset_banner') }])
                }, [
                    _cache[87] || (_cache[87] = _createElementVNode("label", { for: "upload_asset_banner" }, "Banner", -1)),
                    _createElementVNode("div", _hoisted_98, [
                        (_ctx.value.data.asset_banner_endpoint)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                _createElementVNode("img", {
                                    src: _ctx.value.data.asset_banner_endpoint,
                                    alt: "Logo",
                                    class: "object-contain h-20 mx-auto"
                                }, null, 8, _hoisted_100)
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(_component_FileUpload, {
                            label: "Banner",
                            name: "upload_asset_banner",
                            id: "upload_asset_banner",
                            value: _ctx.value
                        }, {
                            default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                                    _createTextVNode(" PNG, JPG or GIF ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["value"]),
                        _cache[86] || (_cache[86] = _createElementVNode("small", null, " The banner that is displayed at the head of the redemption portal. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('upload_asset_banner'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_101, _toDisplayString(_ctx.value.getFieldError('upload_asset_banner')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('upload_icon_one') }])
                }, [
                    _cache[90] || (_cache[90] = _createElementVNode("label", { for: "upload_icon_one" }, "Icon #1", -1)),
                    _createElementVNode("div", _hoisted_102, [
                        (_ctx.value.data.icon_one_endpoint)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                _createElementVNode("img", {
                                    src: _ctx.value.data.icon_one_endpoint,
                                    alt: "Logo",
                                    class: "object-contain h-20 mx-auto"
                                }, null, 8, _hoisted_104)
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(_component_FileUpload, {
                            label: "Icon #1",
                            name: "upload_icon_one",
                            id: "upload_icon_one",
                            value: _ctx.value
                        }, {
                            default: _withCtx(() => [...(_cache[88] || (_cache[88] = [
                                    _createTextVNode(" PNG, JPG or GIF ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["value"]),
                        _cache[89] || (_cache[89] = _createElementVNode("small", null, " The icon displayed on the redemption portal. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('upload_icon_one'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_105, _toDisplayString(_ctx.value.getFieldError('upload_icon_one')), 1))
                        : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                    class: _normalizeClass(["col-span-6 xl:col-span-4", { 'form-control-error': _ctx.value.fieldHasErrors('upload_icon_two') }])
                }, [
                    _cache[93] || (_cache[93] = _createElementVNode("label", { for: "upload_icon_two" }, "Icon #2", -1)),
                    _createElementVNode("div", _hoisted_106, [
                        (_ctx.value.data.icon_two_endpoint)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                _createElementVNode("img", {
                                    src: _ctx.value.data.icon_two_endpoint,
                                    alt: "Logo",
                                    class: "object-contain h-20 mx-auto"
                                }, null, 8, _hoisted_108)
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(_component_FileUpload, {
                            label: "Icon #2",
                            name: "upload_icon_two",
                            id: "upload_icon_two",
                            value: _ctx.value
                        }, {
                            default: _withCtx(() => [...(_cache[91] || (_cache[91] = [
                                    _createTextVNode(" PNG, JPG or GIF ", -1)
                                ]))]),
                            _: 1
                        }, 8, ["value"]),
                        _cache[92] || (_cache[92] = _createElementVNode("small", null, " The icon displayed on the redemption portal on completing a successful order. ", -1))
                    ]),
                    (_ctx.value.fieldHasErrors('upload_icon_two'))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_109, _toDisplayString(_ctx.value.getFieldError('upload_icon_two')), 1))
                        : _createCommentVNode("", true)
                ], 2)
            ])
        ])
    ]));
}
